export default __webpack_public_path__ + "static/media/cryptopunk.a3a1d636.png";